import { MAX_DIRECT_INPUT_COUNT, MAX_SKU_ID_LENGTH } from '@/pages/outbound/singleBatchSetting/consts'

// 서버도 중복을 먼저 걷어낸 뒤 개수를 센다 (BundleConditionService.createOrUpdate · createOrUpdateSku)
export const parseDirectInput = (input: string): string[] => [
  ...new Set(
    input
      .split(/[\n,]/)
      .map((v) => v.trim())
      .filter(Boolean),
  ),
]

// 서버 BundleConditionService.validateSku 와 같은 규칙·순서다.
// 공백만 FE 가 더 엄격하다 — 서버는 trim 후 빈 값만 막아 값 가운데 공백은 통과시킨다
export const validateSkuIds = (skuIds: string[]): string | null => {
  const withSpace = skuIds.find((v) => /\s/.test(v))
  if (withSpace) return `SKU ID에 공백을 포함할 수 없습니다. (${withSpace})`

  const tooLong = skuIds.find((v) => v.length > MAX_SKU_ID_LENGTH)
  if (tooLong) return `SKU ID는 ${MAX_SKU_ID_LENGTH}자 이하만 등록할 수 있습니다. (초과: ${tooLong})`

  const lowercased = skuIds.find((v) => v !== v.toUpperCase())
  if (lowercased) return `SKU ID는 대문자로 입력해주세요. (소문자 포함: ${lowercased})`

  if (skuIds.length > MAX_DIRECT_INPUT_COUNT) return `SKU ID는 ${MAX_DIRECT_INPUT_COUNT.toLocaleString()}개 이하만 등록할 수 있습니다.`

  return null
}

// barcode 축은 flag(feature.outboundSinglePack.skuAxis) OFF 동안만 쓴다 — LOGISPRD-11574 에서 지운다.
// 종전 화면과 같이 개수만 먼저 본다. 나머지 규칙은 서버 validate 가 본다
export const validateBarcodes = (barcodes: string[]): string | null =>
  barcodes.length > MAX_DIRECT_INPUT_COUNT ? `바코드는 ${MAX_DIRECT_INPUT_COUNT.toLocaleString()}개 이하만 등록할 수 있습니다.` : null
